export const STEP_COMPLETED = "EmployeeApplication/STEP_COMPLETED";

export type StepName =
  | "basicInformation"
  | "familyInformation"
  | "chooseMedicalPlan"
  | "chooseDentalPlan"
  | "chooseVisionPlan"
  | "chooseAccidentPlan"
  | "chooseLifePlan"
  | "chooseTermLifePlan"
  | "chooseWholeLifePlan"
  | "chooseShortTermDisabilityPlan"
  | "chooseLongTermDisabilityPlan"
  | "healthAccountInformation"
  | "additionalInformation"
  | "sign";

export type EmployeePolicyResponse = {
  contributions: ContributionFormula;
  availablePlans: Array<"medical" | "dental" | "vision">;
  employeeFormId: string;
  employeePolicyId: string;
  companyIDToken: string;
  adminMode: boolean;
  siteConfig: any;
  abTests: any;
};

export type StepCompletedAction = {
  type: typeof STEP_COMPLETED;
  payload: StepName;
};

export type Action = StepCompletedAction;

export const stepCompleted = (step: StepName) => ({
  type: STEP_COMPLETED,
  payload: step,
});
